
import { defineComponent, defineAsyncComponent, ref, computed, onMounted } from "vue";
import { store } from "@/store";
import useSaveAndContinue from "@/composables/useSaveAndContinue";
import { onBoardingPrintRef } from "@/onboarding/Refs";

const PrintOptions = defineAsyncComponent(() =>
  import("@/components/NavBar/Print/PrintOptions.vue" /* webpackChunkName: "printOptions" */)
);

export default defineComponent({
  name: "PrintButton",
  components: {
    PrintOptions,
  },
  setup() {
    const isPrintedSheetLabel = computed<boolean>(() =>
      store.getters.currentLabelType === "printed" || store.getters.currentLabelType === "blank"
        ? true
        : false
    );
    const isMobile = computed<boolean>(() => store.getters.isMobile);

    /* PRINT OPTIONS START */
    const showPrintOptions = ref(false);
    const printBtn = ref<HTMLButtonElement>();

    onMounted(() => {
      document.addEventListener("click", closePrintOptions);
    });

    const closePrintOptions = (e: MouseEvent) => {
      const target = e.target as Element;
      const dropDown = document.getElementById("drop-down-modal");

      if (target && dropDown && printBtn.value) {
        if (!dropDown.contains(target) && !printBtn.value.contains(target)) {
          showPrintOptions.value = false;
        }
      }
    };

    const handleShowPrintOptions = () => {
      showPrintOptions.value = true;
    };

    const setPrintOptionsPosition = async (dropDown: HTMLDivElement) => {
      if (printBtn.value) {
        const printBtnBCR = printBtn.value.getBoundingClientRect();
        const dropDownBCR = dropDown.getBoundingClientRect();
        const editorWindow = document.getElementById("editor-window") as HTMLDivElement;

        if (isMobile.value) {
          dropDown.style.left = `${editorWindow.getBoundingClientRect().width / 2 -
            dropDownBCR.width / 2}px`;
          dropDown.style.top = `${editorWindow.getBoundingClientRect().top}px`;
        } else {
          dropDown.style.left = `${printBtnBCR.x - dropDownBCR.width}px`;
          dropDown.style.top = `${editorWindow.getBoundingClientRect().top}px`;
        }
      }
    };

    const saveAndContinue = () => {
      showPrintOptions.value = false;

      const saveAndContinueBtn = document.getElementById("save-continue") as HTMLButtonElement;

      if (saveAndContinueBtn) {
        saveAndContinueBtn.textContent = "Saving . . .";
        saveAndContinueBtn.style.opacity = ".4";
        saveAndContinueBtn.disabled = true;
      }

      useSaveAndContinue();
    };
    /* PRINT OPTIONS END */

    return {
      onBoardingPrintRef,
      isPrintedSheetLabel,
      showPrintOptions,
      printBtn,
      handleShowPrintOptions,
      setPrintOptionsPosition,
      saveAndContinue,
    };
  },
});
